export const common = {
  beta: { en: 'Beta', nb: 'Beta' },
  aiSummary: { en: 'AI Summary', nb: 'AI-sammendrag' },
  all: { en: 'All', nb: 'Alle' },
  analysisNoFindings: {
    en: 'Nothing was found in the last analysis.',
    nb: 'Ingenting ble funnet i forrige analyse.',
  },
  asc: { en: 'Ascending', nb: 'Stigende' },
  askAi: { en: 'Ask Volve AI', nb: 'Spør Volve AI' },
  back: { en: 'Back', nb: 'Tilbake' },
  badgeLabels: {
    high: { en: 'High', nb: 'Høy' },
    low: { en: 'Low', nb: 'Lav' },
    medium: { en: 'Medium', nb: 'Middels' },
    missing: { en: 'Missing', nb: 'Mangler' },
    moderate: { en: 'Moderate', nb: 'Moderat' },
    strong: { en: 'Strong', nb: 'Sterk' },
    weak: { en: 'Weak', nb: 'Svak' },
  },
  bidTypes: {
    MAIN_TENDER: { en: 'Tender', nb: 'Anbud' },
    none: { en: 'Select type', nb: 'Velg type' },
    PREQUALIFICATION: { en: 'Prequalification', nb: 'Prekvalifisering' },
  },
  board: { en: 'Board', nb: 'Tavle' },
  cancel: { en: 'Cancel', nb: 'Avbryt' },
  clearFilters: { en: 'Clear filters', nb: 'Fjern filtre' },
  close: { en: 'Close', nb: 'Lukk' },
  continue: { en: 'Continue', nb: 'Fortsett' },
  copied: { en: 'Copied', nb: 'Kopiert' },
  delete: { en: 'Delete', nb: 'Slett' },
  desc: { en: 'Descending', nb: 'Synkende' },
  dismiss: { en: 'Dismiss', nb: 'Lukk' },
  display: { en: 'Display', nb: 'Vis' },
  document: { en: 'Document', nb: 'Dokument' },
  done: { en: 'Done', nb: 'Ferdig' },
  download: { en: 'Download', nb: 'Last ned' },
  edit: { en: 'Edit', nb: 'Rediger' },
  elaborateOn: { en: 'Elaborate on', nb: 'Utvide om' },
  exitFullScreen: { en: 'Exit full screen', nb: 'Avslutt fullskjerm' },
  failed: { en: 'Failed', nb: 'Feilet' },
  favorite: { en: 'Add to favourites', nb: 'Legg til i favoritter' },
  files: { en: 'files', nb: 'filer' },
  filters: {
    noResults: {
      en: 'No results found matching your filters',
      nb: 'Ingen resultater som samsvarer med dine filtre',
    },
    resetFilters: { en: 'Reset filters', nb: 'Tilbakestill filtre' },
  },
  fullScreen: { en: 'Full screen', nb: 'Fullskjerm' },
  languages: {
    'da-DK': { en: 'Danish', nb: 'Dansk' },
    'de-DE': { en: 'German', nb: 'Tysk' },
    'en-US': { en: 'English', nb: 'Engelsk' },
    'es-ES': { en: 'Spanish', nb: 'Spansk' },
    'fi-FI': { en: 'Finnish', nb: 'Finsk' },
    'fr-FR': { en: 'French', nb: 'Fransk' },
    'nb-NO': { en: 'Norwegian', nb: 'Norsk' },
    'pl-PL': { en: 'Polish', nb: 'Polsk' },
    'pt-PT': { en: 'Portuguese', nb: 'Portugisisk' },
    'sv-SE': { en: 'Swedish', nb: 'Svensk' },
  },
  likelihood: { en: 'Likelihood', nb: 'Sannsynlighet' },
  link: { en: 'Link', nb: 'Lenke' },
  list: { en: 'List', nb: 'Liste' },
  next: { en: 'Next', nb: 'Neste' },
  noDocumentsUploaded: {
    en: 'No documents uploaded yet.',
    nb: 'Ingen dokumenter lastet opp ennå.',
  },
  noResults: { en: 'No results', nb: 'Ingen resultater' },
  noResultsDescription: {
    en: 'Nothing matches your search or filters.',
    nb: 'Ingenting samsvarer med søket eller filtrene dine.',
  },
  noTenderPackageDocuments: {
    en: 'Tender package has no documents yet.',
    nb: 'Anbudspakken har ingen dokumenter ennå.',
  },
  notifications: {
    deletedSuccessfully: { en: 'Deleted successfully', nb: 'Slettet' },
    error: {
      en: 'An error occurred, please try again later',
      nb: 'Det oppsto en feil, vennligst prøv igjen senere',
    },
    errorFetchingDocument: {
      en: "Couldn't fetch the document, please try again later.",
      nb: 'Kunne ikke hente dokumentet, vennligst prøv igjen senere.',
    },
    updatedSuccessfully: { en: 'Updated successfully', nb: 'Oppdatert' },
  },
  of: { en: 'of', nb: 'av' },
  open: { en: 'Open', nb: 'Åpne' },
  openInNewTab: { en: 'Open in new tab', nb: 'Åpne i ny fane' },
  or: { en: 'or', nb: 'eller' },
  ordering: { en: 'Ordering', nb: 'Sortering' },
  preparingEditableDocument: {
    en: 'Preparing editable document',
    nb: 'Klargjør redigerbart dokument',
  },
  previous: { en: 'Previous', nb: 'Forrige' },
  priority: { en: 'Priority', nb: 'Prioritet' },
  projectType: {
    BUILDING: { en: 'Building', nb: 'Bygg' },
    ENERGY: { en: 'Energy', nb: 'Energi' },
    INFRASTRUCTURE: { en: 'Infrastructure', nb: 'Infrastruktur' },
  },
  qualification: { en: 'Qualification', nb: 'Kvalifikasjon' },
  reRunAnalysis: { en: 'Rerun analysis', nb: 'Kjør analyse på nytt' },
  reRunAnalysisDescription: {
    en: 'Are you sure you want to rerun the analysis? This will overwrite the current analysis results.',
    nb: 'Er du sikker på at du vil kjøre analysen på nytt? Dette vil overskrive gjeldende analyseresultater.',
  },
  review: { en: 'Review', nb: 'Vurdering' },
  save: { en: 'Save', nb: 'Lagre' },
  scopeSheet: {
    missing: { en: 'Run the scope breakdown first.', nb: 'Kjør omfangsoversikten først.' },
    noPackages: {
      en: 'No post in the scope breakdown has a package yet.',
      nb: 'Ingen poster i omfangsoversikten har en pakke ennå.',
    },
    running: { en: 'The scope breakdown is running.', nb: 'Omfangsoversikten kjøres.' },
  },
  search: { en: 'Search...', nb: 'Søk...' },
  selected: { en: 'selected', nb: 'valgt' },
  severity: { en: 'Severity', nb: 'Alvorlighetsgrad' },
  showLess: { en: 'Show less', nb: 'Vis mindre' },
  showMore: { en: 'Show more', nb: 'Vis mer' },
  somethingWentWrong: { en: 'Something went wrong', nb: 'Noe gikk galt' },
  statement: { en: 'statement', nb: 'uttale' },
  status: { en: 'Status', nb: 'Status' },
  subjects: {
    ambiguity_statement: { en: 'Ambiguities', nb: 'Uklare formuleringer' },
    artifact_sheet_row: { en: 'Sheet row', nb: 'Rad i ark' },
    bid_cv_position: { en: 'CV quality check', nb: 'CV-kvalitetssjekk' },
    bid_draft_document: { en: 'Draft execution plan', nb: 'Utkast til gjennomføringsplan' },
    bid_drafting: { en: 'Draft execution plan', nb: 'Utkast til gjennomføringsplan' },
    bid_methodology: { en: 'Execution plan review', nb: 'Gjennomføringsplan' },
    change_assessment: { en: 'Change analysis', nb: 'Endringsanalyse' },
    chat: { en: 'Chat', nb: 'Chat' },
    chat_message: { en: 'Chat', nb: 'Chat' },
    checklist_run: { en: 'Checklists', nb: 'Sjekklister' },
    clause_scanner_clause: { en: 'Clauses', nb: 'Klausuler' },
    custom_topic_query: { en: 'Summary', nb: 'Sammendrag' },
    custom_topic_statement: { en: 'Extractions', nb: 'Uttrekk' },
    evaluation_conflict_finding: { en: 'Conflicts', nb: 'Motstrid' },
    kg_work_package: { en: 'Work packages', nb: 'Arbeidspakker' },
    kg_work_package_baseline_group: { en: 'Work packages', nb: 'Arbeidspakker' },
    kg_work_package_compliance_item: { en: 'Work packages', nb: 'Arbeidspakker' },
    kg_work_package_leveling_cell: { en: 'Work packages', nb: 'Arbeidspakker' },
    kg_work_package_query_cell: { en: 'Work packages', nb: 'Arbeidspakker' },
    kg_work_package_scope_item: { en: 'Work packages', nb: 'Arbeidspakker' },
    legal_deviation_clause_scanner_result: { en: 'Contract review', nb: 'Kontraktsgjennomgang' },
    legal_deviation_cluster: { en: 'Contract review', nb: 'Kontraktsgjennomgang' },
    legal_deviation_statement: { en: 'Contract review', nb: 'Kontraktsgjennomgang' },
    'saved_source:102': { en: 'Work packages', nb: 'Arbeidspakker' },
    'saved_source:1300': { en: 'Bid comparison', nb: 'Tilbudssammenligning' },
    'saved_source:1400': { en: 'CV quality check', nb: 'CV-kvalitetssjekk' },
    'saved_source:1500': { en: 'Reservations', nb: 'Forbehold' },
    'saved_source:1700': { en: 'Bid compliance checklist', nb: 'Kravsjekk' },
    'saved_source:2100': { en: 'Coverage', nb: 'Dekning' },
    'saved_source:2200': { en: 'Checklists', nb: 'Sjekklister' },
    scope_item: { en: 'Scope breakdown', nb: 'Omfangsoversikt' },
    scope_pack_risk: { en: 'Scope breakdown', nb: 'Omfangsoversikt' },
    standard_deviation_group: { en: 'Technical compliance', nb: 'Teknisk samsvar' },
    standard_deviation_statement: {
      en: 'Technical standard finding',
      nb: 'Funn i teknisk samsvar',
    },
    strengths_weaknesses_statement: { en: 'Brief', nb: 'Hovedtrekk' },
    task: { en: 'Tasks', nb: 'Oppgaver' },
    tender_criterion: { en: 'Tender criteria', nb: 'Anbudskriterier' },
    tender_feedback: { en: 'Tender feedback', nb: 'Anbudstilbakemelding' },
    work_package: { en: 'Work packages', nb: 'Arbeidspakker' },
    work_package_discipline: { en: 'Work packages', nb: 'Arbeidspakker' },
  },
  unfavorite: { en: 'Remove from favourites', nb: 'Fjern fra favoritter' },
  upload: { en: 'Upload', nb: 'Last opp' },
  versionHistory: {
    currentVersion: { en: 'Current version', nb: 'Gjeldende versjon' },
  },
  waitForBidDocumentsIndexing: {
    en: 'Please wait until bid documents are analysed.',
    nb: 'Vent til tilbudsdokumentene er analysert.',
  },
  waitForDocumentsIndexing: {
    en: 'Please wait until documents are analysed.',
    nb: 'Vent til dokumentene er analysert.',
  },
  waitForKeyInformation: {
    en: 'Please wait until Volve AI finishes extracting key information.',
    nb: 'Vent til Volve AI er ferdig med å hente ut nøkkelinformasjon.',
  },
  waitForTenderPackageDocumentsIndexing: {
    en: 'Please wait until tender package documents are analysed.',
    nb: 'Vent til anbudspakkedokumentene er analysert.',
  },
  you: { en: '(you)', nb: '(du)' },
};
